import { useDispatch } from 'react-redux'
import {
    DFM_APPROVED,
    DFM_PENDING_REVISION,
    DFM_WARNING_ACCEPTED,
    ImDfmStateType,
} from '@Admin/AdminQuotingPage/ImDfmSlidesPanel/ImDfmSlide/constants'

import Box from '~/core/Box'
import Button from '~/core/Button'
import Text from '~/core/Text'
import { openChatDrift } from '~/redux-modules/drift'

const VALID_STATUSES = new Set([
    DFM_APPROVED,
    DFM_PENDING_REVISION,
    DFM_WARNING_ACCEPTED,
])

const TEXT_STYLE = { fontSize: '12px', fontWeight: 300 }

type ChangeResponseMsgPropsType = {
    status: ImDfmStateType
}

const ChangeResponseMsg = (props: ChangeResponseMsgPropsType) => {
    const { status } = props

    const dispatch = useDispatch()

    if (!VALID_STATUSES.has(status)) {
        return null
    }

    return (
        <Box alignItems="center" direction="col" marginTop="16px">
            <Text
                color="blackAlpha65"
                style={{ marginBottom: '8px', ...TEXT_STYLE }}
            >
                Need to change your response?
            </Text>
            <Button
                data-test-target="im-dfm-modal-chat-with-us"
                name="chat-with-us"
                placement="slide-action-panel"
                style={TEXT_STYLE}
                onClick={(evt: Event) => {
                    evt.preventDefault()
                    dispatch(openChatDrift())
                }}
            >
                Chat with us
            </Button>
        </Box>
    )
}

export default ChangeResponseMsg
